<template>
  <BaseFieldWrapper
    v-bind="{...$props, ...$attrs}"
    v-on="$listeners"
    :value="value"
  
    v-slot="{vuelidateIns, value, listeners, ske, attrs}"
  >
    <TableDatePickerField class="form-group"
      v-model="date"
      :placeholder="placeholder"
      :updateModelOnConfirmation="updateModelOnConfirmation"

      v-slot="{ rawStartDate, placeholder, openModal }"
    >
      <div class="input-wrapper" @click="openModal">
        <input
          class="form-control"
          :class="[
            vuelidateIns && 'border-danger',
            {notFromTable: !table, tableForm: table}
          ]"

          v-bind="attrs"
          v-on="listeners"
          ref="input"
          placeholder=""
          
          :value="rawStartDate"
          @focus="focus"
        >

        <span v-if="!rawStartDate" class="placeholder">
          <span class="mt-0.5 mr-1">
            <i class="v-icon notranslate mdi mdi-calendar-multiselect theme--light"></i>
          </span>

          {{ placeholder }}
        </span>
      </div>
    </TableDatePickerField>

  </BaseFieldWrapper>
</template>

<script>

import { VDatePicker } from "vuetify/lib"

import BaseFieldWrapper, { props } from "./FormFieldWrapper.vue"
import TableDatePickerField from "./TableDatePickerField.vue"
import FormInput from "./FormInput.vue"

export default {
  props: {
    ...props,

    updateModelOnConfirmation: Boolean,
    table: Boolean,
    placeholder: String,
  },
  name: "base-date-picker",
  components: {
    BaseFieldWrapper,
    VDatePicker,
    TableDatePickerField,
    FormInput,
  },
  data() {
    return {
      date: this.value
    }
  },
  methods: {
    focus() {
      if (!this.date) {
        // this.$refs.input.click()
      }
    },
  },
  watch: {
    value(val) {
      this.date = val
    },
    date(val) {
      this.$emit("input", val)
    },
  },
}

</script>

<style scoped>

input {
  border: 1px solid #bebfc1;
}

</style>

<style>

.form-date-picker td,
.form-date-picker th,
.form-date-picker tr {
  border: none !important;
  padding: 8px;
}

.input-wrapper {
  position: relative;
}

.placeholder {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 8px;
  pointer-events: none;
  width: 100%;
  padding-right: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap !important;
}

.mdi-calendar-multiselect {
  transform: scale(0.85);
}

.form-control {
  border: 1px solid rgba(0, 0, 0, 0.125) !important;
}

.notFromTable.form-control {
  border: 1px solid #bebfc1 !important;
}

.form-control.tableForm {
  min-height: 38px;
}

</style>
